<main>
  <lib-header
    [title]="headerTitle()"
    [iconPath]="headerLogoService.logoSrc()"
    [iconRoute]="'/'"
    [headlineRoute]="'/'"
    [backgroundColor]="headerColorService.color()"
    [showInboxIcon]="isLoggedIn()"
    [unreadCount]="inboxBadge.unreadCount()"
    [inboxRoute]="'/postfach'"
  >
    <lib-menu [user]="user" [showLogoutMenuItem]="true" [logoutRoute]="'logout'">
      <lib-menu-item
        [iconName]="'person'"
        [menuName]="'header.menu.account' | translate"
        [route]="'/account'"
      ></lib-menu-item>
      <lib-menu-item
        [iconName]="'computer'"
        [menuName]="'header.menu.runners' | translate"
        [route]="'/runners'"
      ></lib-menu-item>
      @if (canViewTenantSettings()) {
        <lib-menu-item
          [iconName]="'settings'"
          [menuName]="'header.menu.settings' | translate"
          [route]="'/settings'"
        ></lib-menu-item>
      }
      <lib-menu-item [iconName]="'help'" [menuName]="'header.menu.help' | translate"></lib-menu-item>
    </lib-menu>
  </lib-header>
  <app-server-unavailable-banner></app-server-unavailable-banner>
  <app-breadcrumb></app-breadcrumb>
  <div class="app">
    <router-outlet></router-outlet>
  </div>
</main>
